import React, { useState, Fragment, useEffect } from "react";
import { FlexWrapper } from "@app/components/commonStyles";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, wizardList } from "@app/utils";
import {
  StudentLogo,
  KazooLogo,
  ParentLogo,
  EducatorLogo,
  SmallLeaf,
  LargeLeaf,
  LIWCIcon,
  GoogleSignButton,
  GoogleIcon
} from "@app/assets";
import {
  LayoutContainer,
  LayoutLogo,
  SignLayout,
  OptionCard,
  ImageHolder,
  InfoSection,
  RouteSection,
  OptionCardsWrapper,
  GoogleImageHolder,
} from "./loginLayout.component";
import { webflowUrl,cleverUrl, baseUrl } from "@app/providers";
import { SSOImageHolder } from "../SSOLogin/SSOLogin.component";
import Toast from "../toast";
import { useHistory } from "react-router-dom";
type Props = {
  path: string;
  label: string;
  children?: any;
  hideLogo?: boolean;
  forgotPassword?: boolean;
  classname?: string;
};

export default function HomeComponent({
  path = "",
  label = "",
  children = "",
  hideLogo = false,
  forgotPassword = false,
  classname = "",
}: Props) {
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  useEffect(() => {
    if(localStorage.getItem('error')){
      setShowToast(true);
      setToastMessage({
        type: "error",
        message: localStorage.getItem('error'),
      });
    }
    localStorage.removeItem('error');
  },[]);
  
  
  const tabsList = [
    {
      id: "/parent",
      label: `Sign ${path === "/sign-up" ? "Up for Home Account" : "In to Home Account"
        }`,
      image: ParentLogo,
    },
    {
      id: "/educator",
      label: `Sign ${path === "/sign-up"
        ? "Up to Educator/School Account"
        : "In to Educator/School Account"
        }`,
      image: EducatorLogo,
    },
    {
      id: cleverUrl,
      label: `${path === "/sign-up" ? 'Sign Up' : 'Login' } with Clever`,
      image: LIWCIcon,
    },
    {
      id: baseUrl + 'users/googleClassAuthorize',
      label: `${path === "/sign-up" ? 'Sign Up' : 'Login' } with Google`,
      image: GoogleIcon,
    }
  ];
  if (path === "/sign-in") {
    tabsList.splice(0, 0, {
      id: "/student",
      label: "Sign In as Student",
      image: StudentLogo,
    });
  }

  const [selectedWizard, setWizard] = useState<any>(
    path === "/sign-in" ? wizardList[0] : wizardList[1]
  );
  const { navigate } = useLocation();
  const history = useHistory();
  function navigateTo() {
    navigate("/sign-in");
  }
  function navigateToSignup() {
    navigate("/sign-up");
  }
  const onTabselected = (tab: any) => {
    if(tab.id == cleverUrl || tab.id == baseUrl + 'users/googleClassAuthorize'){
      window.open(tab.id,'_self');
    }else{
      navigate(path + tab.id);
    }
    
  };
  function logoRedirection() {
    window.open(webflowUrl, "_self")
  }
  function cleverRedirectUrl(){
    window.open(cleverUrl,'_self')
  }

  function googleRedirectUrl(){
    window.open(baseUrl + 'users/googleClassAuthorize','_self')
  }
  
  return (
    <Fragment>
      <div className="fullheight">
        {hideLogo ? null : (
          <LayoutLogo>
            <span style={{ cursor: "pointer" }} onClick={() => logoRedirection()}>
              <img alt="" src={KazooLogo} ></img>
            </span>
          </LayoutLogo>
        )}
        <LayoutContainer>
          {!children && (
            <SignLayout className="home">
              <FlexWrapper className="justify-between">
                <RouteSection>
                  <h3 className="primary-header mb-2">{label}</h3>
                  <OptionCardsWrapper>
                    {tabsList.map((each) => (
                      <OptionCard
                        onClick={() => onTabselected(each)}
                        key={each.id}
                        onMouseEnter={() =>
                          setWizard(
                            wizardList.find((wizard) => wizard.id === each.id)
                          )
                        }
                        onMouseLeave={() =>
                          setWizard(
                            path === "/sign-in" ? wizardList[0] : wizardList[1]
                          )
                        }
                      >
                        <ImageHolder>
                          <img
                            className="image cover"
                            src={each.image}
                            alt="User Account Type"
                          ></img>
                        </ImageHolder>
                        <div className="info-with-icon">
                          <span>{each.label}</span>
                          <FontAwesomeIcon
                            icon={faCaretRight}
                            color="#00BE9A"
                          />
                        </div>
                      </OptionCard>
                    ))}
                  </OptionCardsWrapper>
                  {/* <SSOImageHolder>
                    <button onClick={() => cleverRedirectUrl()}> 
                      <img src = {LIWCIcon}></img>
                        Login with Clever
                    </button>
                    <button onClick={() => googleRedirectUrl()}> 
                      <img src = {GoogleIcon}></img>
                        Login with Google
                    </button>
                  </SSOImageHolder> */}
                  
                  
                  <FlexWrapper className="justify-center mt-3">
                    {path === "/sign-in" && (
                      <p>
                        Don’t have an account?
                        <button
                          className="anchor-tag"
                          onClick={navigateToSignup}
                          type="button"
                        >
                          Sign Up
                        </button>
                      </p>
                    )}
                    {path === "/sign-up" && (
                      <p>
                        Already have an account?
                        <button
                          className="anchor-tag"
                          onClick={navigateTo}
                          type="button"
                        >
                          Sign In
                        </button>
                      </p>
                    )}
                  </FlexWrapper>
                </RouteSection>
                <InfoSection>
                  <h3 className="primary-header mb-10">
                    {selectedWizard.name}
                  </h3>
                  <div className="description" dangerouslySetInnerHTML={{ __html: selectedWizard.description }} />
                </InfoSection>
              </FlexWrapper>
              <img alt="" className="leaf-bg-image" src={SmallLeaf}></img>
            </SignLayout>
          )}
          {children && (
            <SignLayout
              className={forgotPassword ? "forgot-pwd-container" : classname}
            >
              {children}{" "}
              <img alt="" className="leaf-bg-image" src={SmallLeaf}></img>
            </SignLayout>
          )}
        </LayoutContainer>
      </div>
      <img alt="" className="leaf-big-bg-image" src={LargeLeaf}></img>
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        onClose={() => setShowToast(false)}
      />
    </Fragment>
  );
}
